import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddNewButton from 'components/ActionButtons/addNewButton';
import { Button } from 'reactstrap';
import List from './list';
import AddDialog from './addDialog';
import ConfirmDialog from 'components/Dialogs/ConfirmDialog';

import * as CustomClearenceAction from 'store/actions/customClearence';

import { t } from 'i18next';

function CustomClearence() {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);
  const [showDelete, setShowDelete] = React.useState(false);

  const dispatch = useDispatch();

  const clearences = useSelector((state) => state.information.clearences);

  const headers = ['no', 'name', 'created_at', ''];
  React.useEffect(() => {
    dispatch(CustomClearenceAction.getAll({}));
  }, [CustomClearenceAction.getAll, dispatch]);

  return (
    <>
      <List
        headers={headers}
        data={clearences}
        onEdit={(data) => {
          setModalOpen(true);
          setEditData(data);
        }}
        onDelete={(data) => {
          setShowDelete(true);
          setEditData(data);
        }}
        buttons={
          <>
            <AddNewButton
              type='custom_clearnece'
              onClick={() => {
                setModalOpen(true);
                setEditData(null);
              }}
            />
            <Button style={{ width: 100 }} size='sm' onClick={() => dispatch(CustomClearenceAction.getAll({}, true))}>
              <i className='fa fa-spinner mr-2' /> {t('refresh')}
            </Button>
          </>
        }
      />
      <AddDialog
        title={
          editData ? `${t('edit')} ${t('sidebar.custom_clearence')}` : `${t('add')} ${t('sidebar.custom_clearence')}`
        }
        editData={editData}
        modalOpen={modalOpen}
        onToggle={(open) => setModalOpen(open)}
        onSubmit={(values) => {
          setModalOpen(false);
          if (editData) dispatch(CustomClearenceAction.update({ ...values, _id: editData?._id }));
          else dispatch(CustomClearenceAction.save(values));
          setTimeout(() => dispatch(CustomClearenceAction.getAll({}, true)), 1000);
        }}
      />
      <ConfirmDialog
        modalOpen={showDelete}
        title={`${t('delete')} ${t('sidebar.custom_clearence')}`}
        body={`${t('confirm_delete')} ${editData?.name}?`}
        onToggle={() => setShowDelete(false)}
        onConfirm={() => {
          setShowDelete(false);
          dispatch(CustomClearenceAction.deleteData(editData?._id));
          setTimeout(() => dispatch(CustomClearenceAction.getAll()), 1000);
        }}
      />
    </>
  );
}

export default CustomClearence;
